import { useEffect, useRef } from 'react';

import type { AnimationItem } from 'lottie-web';

import { ILoadingFullScreen } from '../../../interfaces/globals';
import './LoadingFullScreen.scss';

const LoadingFullScreen = ({ show, text }: ILoadingFullScreen) => {
  const animationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let animation: AnimationItem | undefined;
    let cancelled = false;

    Promise.all([
      import('lottie-web/build/player/lottie_light'),
      import('../../../../assets/animations/loading-spinner.json')
    ])
      .then(([lottie, animationData]) => {
        if (cancelled || !animationRef.current) return;

        animation = lottie.default.loadAnimation({
          container: animationRef.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData.default
        });
      })
      .catch((error) => console.error(error));

    return () => {
      cancelled = true;
      animation?.destroy();
    };
  }, []);

  return (
    <div
      className={`loading-full-screen flex flex-col justify-center items-center origin-center pointer-events-none ${show ? 'loading-full-screen--show opacity-100' : 'opacity-0'}`}
    >
      <div
        ref={animationRef}
        role="img"
        aria-label="Loading"
        className="loading-full-screen__img flex justify-center items-center"
      />
      {text && <div className="loading-full-screen__text text-center m-0">{text}</div>}
    </div>
  );
};

export default LoadingFullScreen;
